import { EmptyState, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const GlobalSearchFirstRunState = () => {
  const intl = useProcurifyIntl()

  return (
    <EmptyState
      context='history'
      header={intl.formatMessage(messages.header)}
      content={<Text>{intl.formatMessage(messages.content)}</Text>}
    />
  )
}
